import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetArticleListAppendSucceed, EGetArticleListActionType } from './types';
import { IArticleList } from '../../../types/articleList';

export const getArticleListAppendSucceed: (data: IArticleList) => TGetArticleListAppendSucceed = actionGenerator<
  EGetArticleListActionType.AppendSucceed,
  IArticleList
>(EGetArticleListActionType.AppendSucceed);
